<template>
  <div class="project-form">
    <el-form ref="form" :model="projectDynamicForm">
      <!-- 防水项目名称选择 -->
      <el-form-item label="防水项目名称">
        <div style="display: flex; align-items: center;">
          <!-- 输入防水项目名称 -->
          <el-input v-model="projectDynamicForm.name" placeholder="请输入防水项目名称"
            style="flex: 1; min-width: 200px;"></el-input>
        </div>
      </el-form-item>

      <!-- 动态表单配置部分 -->
      <el-form-item label="阶段">
        <el-card>
          <div v-for="(stage, stageIndex) in projectStages" :key="stageIndex">
            <el-table :data="stage.forms" border style="width: 100%; margin-top: 20px">
              <!-- 服务阶段名称 -->
              <el-table-column prop="stageName" label="名称" width="120">
                <template v-slot="scope">
                  <el-input size="small" v-model="scope.row.stageName" placeholder="请输入服务阶段名称"></el-input>
                </template>
              </el-table-column>
              <!-- 拿货价 -->
              <el-table-column prop="price" label="拿货价" width="100">
                <template v-slot="scope">
                  <el-input size="small" v-model.number="scope.row.price" type="number" placeholder="请输入拿货价"></el-input>
                </template>
              </el-table-column>
              <!-- 阈值 -->
              <el-table-column prop="threshold" label="阈值" width="100">
                <template v-slot="scope">
                  <el-input size="small" v-model.number="scope.row.threshold" type="number" placeholder="请输入阈值"></el-input>
                </template>
              </el-table-column>
              <!-- 服务阶段排序 -->
              <el-table-column prop="sort" label="排序" width="80">
                <template v-slot="scope">
                  <el-input size="small" v-model="scope.row.sort" placeholder="排序"></el-input>
                </template>
              </el-table-column>
              <!-- 展示控制 -->
              <el-table-column label="是否展示" width="120">
                <template v-slot="scope">
                  <el-switch v-model="scope.row.isShow" active-value="1" inactive-value="2" active-text="是" inactive-text="否"></el-switch>
                </template>
              </el-table-column>
              <!-- 动态表单字段配置 -->
              <el-table-column label="表单配置" min-width="600">
                <template v-slot="scope">
                  <el-table :data="scope.row.formFields" border style="width: 100%" size="small">
                    <el-table-column label="字段名称" width="120">
                      <template v-slot="innerScope">
                        <el-input size="small" v-model="innerScope.row.fieldName" placeholder="字段名"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="控件类型" width="120">
                      <template v-slot="innerScope">
                        <el-select v-model="innerScope.row.inputType" placeholder="请选择控件类型" size="small">
                          <el-option v-for="type in inputTypes" :key="type.id" :label="type.name"
                            :value="type.id"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column label="数据源" width="120">
                      <template v-slot="innerScope">
                        <el-select v-model="innerScope.row.dataSource" placeholder="请选择数据源" size="small">
                          <el-option v-for="source in dataSources" :key="source.id" :label="source.valueName"
                            :value="source.id"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <!-- 是否展示showFlag -->
                    <el-table-column label="是否展示" width="100">
                      <template v-slot="innerScope">
                        <el-radio-group v-model="innerScope.row.showFlag" size="small">
                          <el-radio label="YES">是</el-radio>
                          <el-radio label="NO">否</el-radio>
                        </el-radio-group>
                      </template>
                    </el-table-column>
                    <el-table-column label="客户端" width="100">
                      <template v-slot="innerScope">
                        <el-select v-model="innerScope.row.showClient" placeholder="请选择客户端" clearable multiple size="small">
                          <el-option v-for="client in typeClients" :key="client.value" :label="client.label"
                            :value="client.value"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column label="是否为空" width="100">
                      <template v-slot="innerScope">
                        <el-radio-group v-model="innerScope.row.isNull" size="small">
                          <el-radio label="YES">是</el-radio>
                          <el-radio label="NO">否</el-radio>
                        </el-radio-group>
                      </template>
                    </el-table-column>
                    <!-- 是否计费 -->
                    <el-table-column label="是否计费" width="100">
                      <template v-slot="innerScope">
                        <el-radio-group v-model="innerScope.row.charging" size="small">
                          <el-radio label="YES">是</el-radio>
                          <el-radio label="NO">否</el-radio>
                        </el-radio-group>
                      </template>
                    </el-table-column>
                    <el-table-column label="计费规则" width="120">
                      <template v-slot="innerScope">
                        <el-input size="small" v-model="innerScope.row.expression" placeholder="计费规则" clearable></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="排序" width="80">
                      <template v-slot="innerScope">
                        <el-input size="small" v-model="innerScope.row.sort"></el-input>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column label="上传示例图片" align="center">
                      <template v-slot="innerScope">
                        <ImageUpload action="#" :multiple="true" :inTable="true" :limit="1"
                          @uploaded="(urls) => handleUploaded(urls, stageIndex, innerScope.$index)"
                          :uploaded-images="innerScope.row.picUrl" />
                      </template>
                    </el-table-column> -->
                    <el-table-column align="center" label="操作" width="160">
                      <template v-slot="innerScope">
                        <el-button type="text" size="small"
                          @click="removeField(stageIndex, innerScope.$index)" icon="el-icon-delete">删除</el-button>
                        <el-button type="text" size="small" @click="addField(stageIndex)" icon="el-icon-plus">增加</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <!-- 删除阶段 -->
              <el-table-column align="center" label="操作" width="120">
                <template v-slot>
                  <el-button type="text" size="small" @click="removeStage(stageIndex)" icon="el-icon-delete"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-form-item align="center">
            <el-button type="text" icon="el-icon-plus" size="small" @click="addStage">增加</el-button>
          </el-form-item>
        </el-card>
      </el-form-item>
      <!-- 提交按钮 -->
      <el-form-item align="center">
        <el-button type="text" icon="el-icon-close" @click="handleCancel">取消</el-button>
        <el-button type="text" icon="el-icon-edit" @click="submit">修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { findWaterProofDynamicId, findDataSourceAll, findDataSourceFields, editWaterProofDynamic } from "@/api/work/waterProof/projectDynamic";
// import ImageUpload from "@/components/imageUpload/ImageUpload";

export default {
  name: 'EditForm',
  components: {
    // ImageUpload,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: String,
      required: true
    },
    agentId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      projectDynamicForm: { name: '' },
      projectStages: [],
      typeClients: [
        {
          label: "工程师端",
          value: "JOINS_ENGINEER",
        },
        {
          label: "消费者端",
          value: "JOINS_USER",
        },
        {
          label: "商户端",
          value: "JOINS_MERCHANT",
        }
      ],
      inputTypes: [],
      dataSources: [],
      additionalFields: {}, // 用于存储其他字段
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal && this.projectId) {
          this.getProjectDetail();
        }
      },
      immediate: true
    },
    projectId: {
      handler(newVal) {
        if (newVal && this.visible) {
          this.getProjectDetail();
        }
      }
    }
  },
  created() {
    findDataSourceFields().then(res => {
      this.inputTypes = JSON.parse(res.data);
    });

    findDataSourceAll().then(res => {
      this.dataSources = JSON.parse(res.data).rows;
    });

    if (this.projectId && this.visible) {
      this.getProjectDetail();
    }
  },
  methods: {
    getProjectDetail() {
      // 添加日志，帮助调试
      console.log('获取项目详情，projectId:', this.projectId, 'agentId:', this.agentId);

      // 重置项目阶段数据，避免叠加旧数据
      this.projectStages = [];
      this.projectDynamicForm.name = '';

      findWaterProofDynamicId(this.projectId).then(res => {
        console.log('获取项目详情响应:', res);

        if (res && (res.code === '200' || res.code === 200)) {
          try {
            const parsedData = JSON.parse(res.data);
            console.log('解析后的数据:', parsedData);

            // 处理数据结构，确保正确获取rows数组中的第一条数据
            const data = parsedData.rows && parsedData.rows.length > 0 ? parsedData.rows[0] : parsedData;

            if (!data) {
              console.error('未找到项目数据');
              this.$message.error('未找到项目数据');
              return;
            }

            this.projectDynamicForm.name = data.name || '';
            this.additionalFields = { ...data };

            // 检查list是否存在且为数组
            if (data.list && Array.isArray(data.list)) {
              this.projectStages = data.list.map(stage => ({
                forms: [{
                  ...stage,
                  stageName: stage.name || '',
                  price: stage.price || '',
                  threshold: stage.threshold || '',
                  sort: stage.sort || 0,
                  isShow: String(stage.isShow || '1'),
                  id: stage.id || '',
                  formFields: (stage.dynamicFormRequest && stage.dynamicFormRequest.fields ? stage.dynamicFormRequest.fields.map(field => {
                    const foundType = this.inputTypes.find(type => type.id == field.inputType);
                    return {
                      ...field,
                      id: field.id || '',
                      fieldName: field.fieldName || '',
                      inputType: foundType ? foundType.id : '',
                      dataSource: field.dataSource || '',
                      isNull: field.isNull || 'NO',
                      showFlag: field.showFlag || 'YES',
                      showClient: field.showClient ? field.showClient.split(',') : [],
                      charging: field.charging || 'NO',
                      expression: field.expression || '',
                      sort: field.sort || 0,
                      // picUrl: (field.picUrl || '').split(',').filter(url => url).map(url => ({ 
                      //   url: url, 
                      //   name: url.substring(url.lastIndexOf('/') + 1) 
                      // })),
                    };
                  }) : []),
                }],
              }));
              console.log('处理后的项目阶段数据:', this.projectStages);
            } else {
              console.warn('项目数据中没有list或不是数组，使用空数组');
              this.projectStages = [];
            }
          } catch (error) {
            console.error('解析数据时出错:', error);
            this.$message.error('解析数据失败');
          }
        } else {
          console.error('请求失败，响应码:', res.code, '消息:', res.message);
          this.$message.error(res.message || '获取项目详情失败');
        }
      }).catch(error => {
        console.error('获取项目详情接口调用失败:', error);
        this.$message.error('请求失败，请稍后重试');
      });
    },
    // 更新图片成功
    handleUploaded(urls, stageIndex, fieldIndex) {
      if (this.projectStages[stageIndex] && this.projectStages[stageIndex].forms[0].formFields[fieldIndex]) {
        this.projectStages[stageIndex].forms[0].formFields[fieldIndex].picUrl = urls;
      }
    },
    addStage() {
      this.projectStages.push({
        forms: [{
          stageName: '',
          price: '',
          threshold: '',
          sort: '',
          isShow: '1',
          formFields: [{
            fieldName: '',
            inputType: '',
            dataSource: '',
            showClient: '',
            charging: '',
            expression: '',
            sort: '',
            isNull: '',
            // picUrl: [],
          }]
        }]
      });
    },
    removeStage(stageIndex) {
      this.projectStages.splice(stageIndex, 1);
    },
    addField(stageIndex) {
      this.projectStages[stageIndex].forms[0].formFields.push({
        fieldName: '',
        inputType: '',
        dataSource: '',
        isNull: '',
        showClient: '',
        charging: '',
        expression: '',
        sort: '',
        // picUrl: [],
      });
    },
    removeField(stageIndex, fieldIndex) {
      this.projectStages[stageIndex].forms[0].formFields.splice(fieldIndex, 1);
    },
    submit() {
      // 构建请求数据
      const params = {
        ...this.additionalFields,
        id: this.projectId,
        agentId: this.agentId,
        name: this.projectDynamicForm.name,
        type: 'WATERPROOF_PROJECT',
        list: this.projectStages.map(stage => ({
          ...stage.forms[0],
          name: stage.forms[0].stageName,
          price: stage.forms[0].price,
          threshold: stage.forms[0].threshold,
          sort: stage.forms[0].sort,
          isShow: stage.forms[0].isShow,
          type: 'WATERPROOF_PROJECT',
          id: stage.forms[0].id ? stage.forms[0].id : '',
          dynamicFormRequest: {
            ...stage.forms[0].dynamicFormRequest,
            fields: stage.forms[0].formFields.map(field => ({
              ...field,
              id: field.id ? field.id : '',
              fieldName: field.fieldName,
              inputType: field.inputType,
              dataSource: field.dataSource,
              isNull: field.isNull,
              showClient: field.showClient.join(','), // 将数组转换为逗号分隔的字符串
              charging: field.charging,
              expression: field.expression,
              sort: field.sort,
              // picUrl: field.picUrl.map(url => (typeof url === 'string' ? url : url.url)).join(','),
            }))
          }
        }))
      };

      // 提交数据
      editWaterProofDynamic(params).then(res => {
        if (res.code === '200') {
          this.$message.success('修改成功');
          this.$emit('submit-success');
          this.$emit('close');
        } else {
          this.$message.error(res.message || '修改失败');
        }
      }).catch(error => {
        this.$message.error('请求失败: ' + error.message);
      });
    },
    handleCancel() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
.project-form {
  max-height: 100vh;
  overflow-y: auto;
}
</style>
